import DeviceControlController from './device_control_controller'

export default class extends DeviceControlController {}
